<template>
	<div>	
		<Tile title="Wilkommen" width="100%" :buttons="buttons" @click="setOrganisation">
			<template v-slot:content>
				<p>You don't currently have any organisations or assessements associated with your account.</p>
				<p>Please indicate which hospital you would like to participate for.</p>
				<v-autocomplete v-model="organisation" :items="organisations" item-value="id" item-text="name" multiple></v-autocomplete>
				<v-checkbox v-model="self_identified_lead_responent" label="I would like to lead my organisation's assessment"></v-checkbox>
				
			</template>
		</Tile>
	</div>
</template>
<script type="text/javascript">
	import Vuex from "vuex";
	import Tile from "@/components/elements/Tile";
	export default {
		name: "SetUpMyOrganistion",
		data: () => {
			return {			
				organisation: [],
				self_identified_lead_responent: false,
				submitted: false,
			}
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				organisations: state => state.organisations
			}),
			buttons() {
				var buttons = [];
				if( !this.submitted && this.organisation ){
					buttons.push(
						{	
							color: "green",
							emit: "click"
						}
					)
				}
				return buttons;
			}
		},
		components: {
			Tile
		},
		methods: {
			setOrganisation(){
				var update = {
					organisation: this.organisation, 
					self_identified_lead_responent: this.self_identified_lead_responent
				}

				this.$store.dispatch("updateDoc", 
					{
						doc:  `users/${this.user.id}`,
						data: update,
						action:  "update"
					} 
				).then(() => {
					this.submitted = true;
				})

			}
		}
	}
</script>